var _labelCache = {};
var _onSaleByHandle = {};
var _stockStatusByHandle = {};
var _stockDateByHandle = {};
var _inventoryByHandle = {};
var _productDataByHandle = {};
var _productImageByHandle = {};
var _variantCountByHandle = {};
var _hasRealOptionsByHandle = {};
var _shopifyProductJsonPromises = {};

/** PLP InstantSearch hits + PDP Algolia Recommend horizontal slider cards */
function _algoliaProductCardSelector() {
  return '.ais-Hits-item, [id^="alg-recommend-wrapper"] .uic-HorizontalSlider-item';
}

function _isRecommendSliderItem(el) {
  return !!(el && el.classList && el.classList.contains('uic-HorizontalSlider-item') &&
    el.closest && el.closest('[id^="alg-recommend-wrapper"]'));
}

function _normalizeShopifyProductId(raw) {
  if (raw == null || raw === '') return '';
  var s = String(raw).trim();
  var m = s.match(/Product\/(\d+)/i);
  if (m) return m[1];
  if (/^\d+$/.test(s)) return s;
  return s;
}

function _fetchShopifyProductJson(handle) {
  if (_shopifyProductJsonPromises[handle]) return _shopifyProductJsonPromises[handle];
  _shopifyProductJsonPromises[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js')
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (data) {
      if (!data) return null;
      return data.product ? data : { product: data };
    })
    .catch(function () { return null; });
  return _shopifyProductJsonPromises[handle];
}

var _liveInvConfirmedHandles = {};
var _liveInvObserver = null;

var _injectorFrame = 0;

function _runInjectors() {
  _fixImageLinkUrls();
  _injectProductImagesFromCache();
  _injectLabelsFromCache();
  _injectStockStatusFromCache();
  _injectKlaviyoReviews();
  _injectCompareButtons();
  _injectAlgoliaRecommendTooltip();
  _observeCardsForLiveInventory();
}

function _scheduleInjectors() {
  if (_injectorFrame) return;
  var raf = window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : function (cb) { return setTimeout(cb, 16); };
  _injectorFrame = raf(function () {
    _injectorFrame = 0;
    _runInjectors();
  });
}

/** Map a live Shopify product JSON object to the _inventoryByHandle shape. */
function _recomputeInventoryFromShopifyJson(product) {
  var variants = (product && Array.isArray(product.variants)) ? product.variants : [];
  if (!variants.length) return null;

  var anyAvailable = variants.some(function (v) { return v.available === true; });
  var hasAnyQty = variants.some(function (v) { return typeof v.inventory_quantity === 'number'; });
  var totalQty = hasAnyQty ? variants.reduce(function (sum, v) {
    return sum + (typeof v.inventory_quantity === 'number' ? v.inventory_quantity : 0);
  }, 0) : null;

  return {
    available:            anyAvailable,
    inventory_quantity:   totalQty,
    inventory_management: variants[0].inventory_management || null,
    inventory_policy:     variants[0].inventory_policy || null
  };
}

function _applyLiveInventory(handle, item) {
  _fetchShopifyProductJson(handle).then(function (data) {
    var product = data && data.product;
    var liveInv = _recomputeInventoryFromShopifyJson(product);

    var prevInv = _inventoryByHandle[handle] || null;
    var prevAvailable = prevInv ? _isInventoryAvailable(prevInv) : null;

    if (liveInv) {
      _inventoryByHandle[handle] = liveInv;
    }
    _liveInvConfirmedHandles[handle] = true;

    var effectiveInv = _inventoryByHandle[handle] || null;
    var effectiveAvailable = effectiveInv ? _isInventoryAvailable(effectiveInv) : null;

    var badgeChanged = !prevInv ||
      prevAvailable !== effectiveAvailable ||
      (liveInv && (
        prevInv.inventory_quantity !== liveInv.inventory_quantity ||
        prevInv.inventory_policy !== liveInv.inventory_policy
      ));
    if (badgeChanged) {
      var card = (item && item.isConnected) ? item : _algoliaCardByHandle(handle);
      var staleWrapper = card ? card.querySelector('.ais-hit--stock-status-wrapper') : null;
      if (staleWrapper && staleWrapper.parentNode) {
        staleWrapper.parentNode.removeChild(staleWrapper);
      }
    }

    _scheduleInjectors();
  });
}

/** Locate a rendered Algolia card by its product handle. */
function _algoliaCardByHandle(handle) {
  var cards = document.querySelectorAll(_algoliaProductCardSelector());
  for (var i = 0; i < cards.length; i++) {
    var link = cards[i].querySelector('a[href*="/products/' + handle + '"]');
    if (link) return cards[i];
  }
  return null;
}

/** Reconcile a card's ATC button against live Shopify inventory while injecting it. */
function _reconcileAtcWithLiveInventory(handle) {
  _applyLiveInventory(handle, null);
}

/** Fetch live JSON for one card's handle and re-run badge + ATC injectors if stock changed. */
function _refreshLiveInventoryForItem(item) {
  var link = item.querySelector('a[href*="/products/"]');
  if (!link) return;
  var match = (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
  if (!match) return;
  _applyLiveInventory(match[1], item);
}

/** Observe currently-rendered cards; refresh live inventory as each scrolls into view. */
function _observeCardsForLiveInventory() {
  var liveEnabled = !(window.themeSettings && window.themeSettings.liveInventoryRefresh === false);
  if (!liveEnabled) return;
  if (typeof IntersectionObserver !== 'function') return;

  if (!_liveInvObserver) {
    _liveInvObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        _liveInvObserver.unobserve(entry.target);
        _refreshLiveInventoryForItem(entry.target);
      });
    }, { rootMargin: '200px 0px' });
  }

  document.querySelectorAll(_algoliaProductCardSelector()).forEach(function (item) {
    var link = item.querySelector('a[href*="/products/"]');
    var m = link ? (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/) : null;
    var handle = m ? m[1] : '';
    if (!handle) return;
    if (item.getAttribute('data-live-inv-observed') === handle) return;
    item.setAttribute('data-live-inv-observed', handle);
    _liveInvObserver.observe(item);
  });
}

function _remountKlaviyoStarNode(widget) {
  var parent = widget && widget.parentNode;
  if (!parent) return;
  var clone = widget.cloneNode(true);
  parent.replaceChild(clone, widget);
}

function _klaviyoWidgetHasRendered(el) {
  if (!el) return false;
  if (el.querySelector('.kl_reviews__star_rating_widget')) return true;
  if (el.shadowRoot && el.shadowRoot.querySelector('.kl_reviews__star_rating_widget')) return true;
  return false;
}

function _ensureKlaviyoShopifyProductIdForRecommend(handle, item) {
  if (!_isRecommendSliderItem(item) || !handle || !item) return;
  if (item.getAttribute('data-klaviyo-shopify-hydrated') === handle) return;
  _fetchShopifyProductJson(handle).then(function (data) {
    var widget = item.querySelector('.klaviyo-star-rating-widget');
    if (!widget) return;
    var p = data && data.product;
    if (!p || p.id == null) return;
    widget.setAttribute('data-id', String(p.id));
    if (p.title) widget.setAttribute('data-product-title', p.title);
    if (p.product_type != null) widget.setAttribute('data-product-type', p.product_type);
    _remountKlaviyoStarNode(widget);
    item.setAttribute('data-klaviyo-shopify-hydrated', handle);
    _triggerKlaviyoRescan();
  });
}

function _hitIsOnSale(hit) {
  if (!hit) return false;
  var price = hit.price != null ? Number(hit.price) : NaN;
  var compare = hit.compare_at_price != null ? Number(hit.compare_at_price) : NaN;
  if (isNaN(price) || isNaN(compare)) return false;
  return compare > price;
}

function _resolveVariantId(hit) {
  if (!hit) return '';

  if (hit.variant_id && Number(hit.variant_id) > 0) {
    return String(hit.variant_id);
  }
  if (hit.default_variant_id && Number(hit.default_variant_id) > 0) {
    return String(hit.default_variant_id);
  }

  var variants = Array.isArray(hit.variants) ? hit.variants : [];
  if (variants.length === 0) {
    return '';
  }

  for (var i = 0; i < variants.length; i++) {
    var v = variants[i];
    var vid = v.id || v.variant_id;
    if (!vid || Number(vid) <= 0) continue;
    var isAvail = v.inventory_available === true || v.inventory_available == 1 ||
                  v.available === true || v.available == 1;
    if (isAvail) {
      return String(vid);
    }
  }

  for (var j = 0; j < variants.length; j++) {
    var vf = variants[j];
    var vfid = vf.id || vf.variant_id;
    if (vfid && Number(vfid) > 0) {
      return String(vfid);
    }
  }

  return '';
}

function _slugify(str) {
  return str.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
}


function _whenAlgoliaShopifyHooksReady(registerFn) {
  function tryRegister() {
    var shop = typeof window !== 'undefined' ? window.algoliaShopify : null;
    if (!shop || !shop.hooks || typeof shop.hooks.registerHook !== 'function') {
      return false;
    }
    registerFn(shop);
    return true;
  }

  if (tryRegister()) return;

  document.addEventListener('algolia.hooks.initialize', tryRegister);

  var attempts = 0;
  var pollId = setInterval(function () {
    attempts += 1;
    if (tryRegister() || attempts >= 150) {
      clearInterval(pollId);
    }
  }, 100);
}

function _isWishlistOnAlgoliaPlpEnabled() {
  var htmlAttr = document.documentElement.getAttribute('data-kingsley-wishlist-algolia-plp');
  if (htmlAttr === 'false') return false;
  if (htmlAttr === 'true') return true;
  if (!window.themeSettings || window.themeSettings.enableWishlistOnAlgoliaPlp == null) {
    return true;
  }
  var v = window.themeSettings.enableWishlistOnAlgoliaPlp;
  return v !== false && v !== 'false' && v !== 0;
}

function _isCompareOnAlgoliaPlpEnabled() {
  var htmlAttr = document.documentElement.getAttribute('data-kingsley-compare-algolia-plp');
  if (htmlAttr === 'false') return false;
  if (htmlAttr === 'true') return true;
  if (!window.themeSettings || window.themeSettings.enableCompareOnAlgoliaPlp == null) {
    return true;
  }
  var v = window.themeSettings.enableCompareOnAlgoliaPlp;
  return v !== false && v !== 'false' && v !== 0;
}

function _isAlgoliaRecommendTooltipEnabled() {
  var htmlAttr = document.documentElement.getAttribute('data-kingsley-algolia-recommend-tooltip');
  if (htmlAttr === 'false') return false;
  if (htmlAttr === 'true') return true;
  if (!window.themeSettings || window.themeSettings.enableAlgoliaRecommendTooltip == null) {
    return true;
  }
  var v = window.themeSettings.enableAlgoliaRecommendTooltip;
  return v !== false && v !== 'false' && v !== 0;
}

function _algoliaRecommendTooltipText() {
  var text = window.themeSettings && window.themeSettings.algoliaRecommendTooltipText;
  return typeof text === 'string' ? text.trim() : '';
}

/** Help icon + hover/focus tooltip beside the Algolia Recommend heading (app block, so injected client-side). */
function _injectAlgoliaRecommendTooltip() {
  if (!_isAlgoliaRecommendTooltipEnabled()) return;
  var text = _algoliaRecommendTooltipText();
  if (!text) return;

  document.querySelectorAll('[id^="alg-recommend-wrapper"] .alg-recommend-title').forEach(function (title) {
    if (title.querySelector('.alg-recommend-tooltip')) return;

    var wrap = document.createElement('span');
    wrap.className = 'alg-recommend-tooltip';

    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'alg-recommend-tooltip__trigger';
    trigger.setAttribute('aria-label', 'About these recommendations');
    trigger.innerHTML =
      '<svg viewBox="0 0 24 24" focusable="false" aria-hidden="true">' +
      '<circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="1.6"></circle>' +
      '<path d="M9.6 9.2a2.4 2.4 0 1 1 3.2 2.27c-.5.19-.8.66-.8 1.19v.84" fill="none" stroke="currentColor" ' +
      'stroke-width="1.6" stroke-linecap="round"></path>' +
      '<circle cx="12" cy="16.4" r="1" fill="currentColor"></circle>' +
      '</svg>';

    var bubble = document.createElement('span');
    bubble.className = 'alg-recommend-tooltip__content';
    bubble.setAttribute('role', 'tooltip');
    bubble.textContent = text;

    var bubbleId = 'alg-recommend-tooltip-' + (++_algoliaRecommendTooltipSeq);
    bubble.id = bubbleId;
    trigger.setAttribute('aria-describedby', bubbleId);

    wrap.appendChild(trigger);
    wrap.appendChild(bubble);
    title.appendChild(wrap);
  });
}

var _algoliaRecommendTooltipSeq = 0;

var _algoliaWishlistOffStyleId = 'kingsley-algolia-wishlist-off';
var _algoliaWishlistPurgeTimer = null;

function _purgeAlgoliaWishlistIcons() {
  document.querySelectorAll(_algoliaProductCardSelector()).forEach(function (item) {
    item.querySelectorAll(
      '.wishlist-hero-custom-button, .wishlisthero-floating, .wlh-algolia-fallback-btn, [data-wlh-id]'
    ).forEach(function (el) {
      if (el.closest('header, .site-header, .wishlist-hero-header-icon')) return;
      el.remove();
    });
  });
}

function _applyAlgoliaWishlistPlpVisibility() {
  var enabled = _isWishlistOnAlgoliaPlpEnabled();
  var styleEl = document.getElementById(_algoliaWishlistOffStyleId);

  if (!enabled) {
    _purgeAlgoliaWishlistIcons();
    if (!styleEl) {
      styleEl = document.createElement('style');
      styleEl.id = _algoliaWishlistOffStyleId;
      styleEl.textContent = [
        '.ais-page .wishlist-hero-custom-button,',
        '.ais-page .wishlisthero-floating,',
        '.ais-Hits-item .wishlist-hero-custom-button,',
        '.ais-Hits-item .wishlisthero-floating,',
        '[id^="alg-recommend-wrapper"] .wishlist-hero-custom-button,',
        '[id^="alg-recommend-wrapper"] .wishlisthero-floating',
        '{ display: none !important; visibility: hidden !important; pointer-events: none !important; }'
      ].join('\n');
      document.head.appendChild(styleEl);
    }
    clearTimeout(_algoliaWishlistPurgeTimer);
    _algoliaWishlistPurgeTimer = setTimeout(_purgeAlgoliaWishlistIcons, 400);
    setTimeout(_purgeAlgoliaWishlistIcons, 1200);
    return;
  }

  if (styleEl) styleEl.remove();
}

function _scheduleAlgoliaWishlistPlpVisibility() {
  _applyAlgoliaWishlistPlpVisibility();
}

function _appendAlgoliaWishlistButton(wrapper, handle, pData, productUrl) {
  if (!_isWishlistOnAlgoliaPlpEnabled()) return;
  var wlh = document.createElement('div');
  wlh.className = 'wishlist-hero-custom-button';
  wlh.setAttribute('data-wlh-id', pData.id || '');
  wlh.setAttribute('data-wlh-link', productUrl);
  wlh.setAttribute('data-wlh-variantid', pData.variantId || '');
  wlh.setAttribute('data-wlh-price', pData.price != null ? String(pData.price) : '');
  wlh.setAttribute('data-wlh-name', pData.title || '');
  wlh.setAttribute('data-wlh-image', pData.image || '');
  wlh.setAttribute('data-wlh-mode', 'icon_only');
  wlh.setAttribute('data-wlh-view', 'Collection');
  wlh.style.cssText = 'left: auto;';
  wrapper.appendChild(wlh);
}

function _appendAlgoliaCompareButton(wrapper, handle) {
  if (!_isCompareOnAlgoliaPlpEnabled()) return;
  var compareEl = document.createElement('div');
  compareEl.className = 'sp-compare-custom-collection';
  compareEl.setAttribute('product-handle', handle);
  wrapper.appendChild(compareEl);
}

function _syncAlgoliaWishlistCompareWrapper(wrapper, handle, pData, productUrl) {
  if (!wrapper) return;

  var showWishlist = _isWishlistOnAlgoliaPlpEnabled();
  var showCompare = _isCompareOnAlgoliaPlpEnabled();
  var existingWlh = wrapper.querySelector('.wishlist-hero-custom-button');
  var existingCompare = wrapper.querySelector('.sp-compare-custom-collection');

  if (!showWishlist && existingWlh) existingWlh.remove();
  if (!showCompare && existingCompare) existingCompare.remove();

  if (showWishlist && !existingWlh) {
    _appendAlgoliaWishlistButton(wrapper, handle, pData, productUrl);
  } else if (showWishlist && existingWlh && pData.id) {
    existingWlh.setAttribute('data-wlh-id', pData.id);
    existingWlh.setAttribute('data-wlh-link', productUrl);
    existingWlh.setAttribute('data-wlh-variantid', pData.variantId || '');
    existingWlh.setAttribute('data-wlh-price', pData.price != null ? String(pData.price) : '');
    existingWlh.setAttribute('data-wlh-name', pData.title || '');
    existingWlh.setAttribute('data-wlh-image', pData.image || '');
  }

  if (showCompare && !existingCompare) {
    _appendAlgoliaCompareButton(wrapper, handle);
  }

  if (!wrapper.children.length) {
    wrapper.remove();
  }
}

var _controlNavGuardBound = false;
function _ensureControlNavGuard() {
  if (_controlNavGuardBound) return;
  _controlNavGuardBound = true;

  ['click', 'mousedown', 'mouseup', 'touchstart', 'pointerdown'].forEach(function (evtName) {
    document.addEventListener(evtName, function (e) {
      if (e._wlhSynthetic) return;
      var target = e.target;
      if (!target || !target.closest) return;
      var inControls = target.closest('.compare-wishlist--algolia-hooks');
      if (!inControls) return;
      if (target.closest('.sp-compare-custom-collection')) return;
      if (target.closest('.wishlist-hero-custom-button')) return;
      e.preventDefault();
      e.stopPropagation();
    }, true);
  });
}

function _syncAlgoliaPlpItemListSchema(results) {
  var base = typeof window !== 'undefined' ? window.__kingsleyCollectionSeo : null;
  if (!base || base.pageType !== 'collection') return;

  var schemaEl = document.getElementById('kingsley-collection-schema');
  if (!schemaEl || !results || !results.length) return;

  var primary = null;
  for (var ri = 0; ri < results.length; ri++) {
    if (results[ri] && Array.isArray(results[ri].hits) && results[ri].hits.length) {
      primary = results[ri];
      break;
    }
  }
  if (!primary) return;

  var hits = primary.hits;
  var page = primary.page != null ? Number(primary.page) : 0;
  var hitsPerPage = primary.hitsPerPage != null ? Number(primary.hitsPerPage) : hits.length;
  var offset = page * hitsPerPage;
  var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';

  var elements = hits.map(function (hit, index) {
    var productUrl = hit.url;
    if (!productUrl && hit.handle) {
      productUrl = location.protocol + '//' + location.host + '/products/' + hit.handle;
    }
    var item = {
      '@type': 'Product',
      name: hit.title || hit.name || '',
      url: productUrl
    };
    var image = hit.product_image || hit.image || hit.image_url || null;
    if (image) {
      item.image = image.indexOf('http') === 0 ? image : ('https:' + image);
    }
    if (hit.price != null && !isNaN(Number(hit.price))) {
      item.offers = {
        '@type': 'Offer',
        price: Number(hit.price),
        priceCurrency: currency,
        availability: 'https://schema.org/InStock',
        url: productUrl
      };
    }
    return {
      '@type': 'ListItem',
      position: offset + index + 1,
      item: item
    };
  });

  var schema;
  try {
    schema = JSON.parse(schemaEl.textContent);
  } catch (e) {
    return;
  }

  if (!schema.mainEntity) {
    schema.mainEntity = { '@type': 'ItemList' };
  }
  schema.mainEntity['@type'] = 'ItemList';
  schema.mainEntity.numberOfItems = primary.nbHits != null ? primary.nbHits : base.productsCount;
  schema.mainEntity.itemListElement = elements;
  schemaEl.textContent = JSON.stringify(schema);
}

function _processAlgoliaResponse(data) {
  var results = (data && data.results) ? data.results : null;
  if (!results && data && Array.isArray(data.hits)) {
    results = [{ hits: data.hits }];
  }
  if (!results && Array.isArray(data)) {
    results = data;
  }
  if (!results) {
    return;
  }

  _syncAlgoliaPlpItemListSchema(results);

  results.forEach(function (result) {
    (result.hits || []).forEach(function (hit) {
      if (!hit.handle) {
        return;
      }
      var label = hit.meta && hit.meta.custom && hit.meta.custom.product_label;
      if (label) {
        _labelCache[hit.handle] = String(label).trim();
      }
      if (_hitIsOnSale(hit)) {
        _onSaleByHandle[hit.handle] = true;
      }
      var stockStatus = hit.meta && hit.meta.custom && hit.meta.custom.custom_stock_status;
      if (stockStatus) {
        _stockStatusByHandle[hit.handle] = String(stockStatus).trim();
      }
      var stockDate = hit.meta && hit.meta.custom && hit.meta.custom.stock_expected_date;
      if (stockDate) {
        _stockDateByHandle[hit.handle] = String(stockDate).trim();
      }
      var invAvailable   = hit.inventory_available != null ? hit.inventory_available
                         : (hit.available != null ? hit.available : null);
      var invQty         = hit.inventory_quantity != null ? Number(hit.inventory_quantity) : null;
      var invManagement  = hit.inventory_management || null;
      var invPolicy      = hit.inventory_policy || null;

      if (invAvailable === null && invQty === null) {
        var hitVariants = hit.variants;
        if (Array.isArray(hitVariants) && hitVariants.length > 0) {
          var anyAvailable = hitVariants.some(function (v) {
            return v.inventory_available === true || v.inventory_available == 1 ||
                   v.available === true || v.available == 1;
          });
          var totalQty = hitVariants.reduce(function (sum, v) { return sum + (Number(v.inventory_quantity) || 0); }, 0);
          invAvailable  = anyAvailable;
          invQty        = totalQty;
          invManagement = hitVariants[0].inventory_management || invManagement;
          invPolicy     = hitVariants[0].inventory_policy     || invPolicy;
        }
      }

      _inventoryByHandle[hit.handle] = {
        available:            invAvailable,
        inventory_quantity:   invQty,
        inventory_management: invManagement,
        inventory_policy:     invPolicy
      };

      var variantCount = Array.isArray(hit.variants) ? hit.variants.length : (hit.variants_count != null ? hit.variants_count : 1);
      _variantCountByHandle[hit.handle] = variantCount;

      var hasRealOptions = false;
      var hitOptions = hit.options || hit.options_with_values || [];

      if (Array.isArray(hitOptions) && hitOptions.length > 0) {
        hasRealOptions = hitOptions.some(function (opt) {
          var optName = (typeof opt === 'string' ? opt : (opt.name || '')).toLowerCase().trim();
          if (optName === 'title' || optName === 'default title') return false;
          var optValues = Array.isArray(opt.values) ? opt.values : (typeof opt === 'string' ? [opt] : []);
          if (optValues.length === 1) {
            var valLower = String(optValues[0]).toLowerCase().trim();
            if (valLower === 'default title' || valLower === 'default') return false;
          }
          return optValues.length > 1 || (optName !== 'title' && optName !== 'default title');
        });
      } else if (hitOptions && typeof hitOptions === 'object' && !Array.isArray(hitOptions)) {
        var optionKeys = Object.keys(hitOptions);
        hasRealOptions = optionKeys.some(function (key) {
          var k = key.toLowerCase().trim();
          return k !== 'title' && k !== 'default title';
        });
        if (!hasRealOptions && optionKeys.length > 1) {
          hasRealOptions = true;
        }
      } else if (variantCount > 1) {
        hasRealOptions = true;
      }
      _hasRealOptionsByHandle[hit.handle] = hasRealOptions;

      var productId = _normalizeShopifyProductId(
        hit.shopify_product_id || hit.product_id || hit.id || hit.objectID || ''
      );
      var variantId = _resolveVariantId(hit);
      var price     = hit.price != null ? Number(hit.price) : 0;
      var title     = hit.title || hit.name || '';
      var image     = hit.product_image || hit.image || (hit.images && hit.images[0]) || '';
      if (image && image.indexOf('cdn.shopify.com') !== -1) {
        image = image.replace(/_\d+x(\d+)?\./, '_1024x.');
      }

      if (hit.product_image) {
        var productImage = String(hit.product_image);
        _productImageByHandle[hit.handle] = productImage.indexOf('http') === 0
          ? productImage
          : ('https:' + productImage);
      }

      var minQty = _parseMinQty(hit.meta && hit.meta.custom && hit.meta.custom.min_qty);

      _productDataByHandle[hit.handle] = {
        id:          String(productId),
        variantId:   variantId,
        price:       price,
        title:       title,
        image:       image,
        productType: hit.product_type || hit.type || '',
        minQty:      minQty
      };
    });
  });
}

var _SS_MONTHS_FULL  = ['January','February','March','April','May','June','July','August','September','October','November','December'];
var _SS_MONTHS_SHORT = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
var _SS_DAYS_FULL    = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
var _SS_DAYS_SHORT   = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];

function _ssPad(n) { return String(n).padStart(2, '0'); }

function _ssFormatDate(dateStr, fmt) {
  if (!dateStr) return '';
  var parts = dateStr.split('-');
  var d = new Date(Date.UTC(+parts[0], +parts[1] - 1, +parts[2]));
  return fmt
    .replace('%B', _SS_MONTHS_FULL[d.getUTCMonth()])
    .replace('%b', _SS_MONTHS_SHORT[d.getUTCMonth()])
    .replace('%m', _ssPad(d.getUTCMonth() + 1))
    .replace('%d', _ssPad(d.getUTCDate()))
    .replace('%e', String(d.getUTCDate()).padStart(2, ' '))
    .replace('%Y', String(d.getUTCFullYear()))
    .replace('%y', String(d.getUTCFullYear()).slice(-2))
    .replace('%A', _SS_DAYS_FULL[d.getUTCDay()])
    .replace('%a', _SS_DAYS_SHORT[d.getUTCDay()]);
}

function _ssOffsetDate(offsetDays, fmt) {
  var d = new Date();
  d.setDate(d.getDate() + offsetDays);
  return fmt
    .replace('%B', _SS_MONTHS_FULL[d.getMonth()])
    .replace('%b', _SS_MONTHS_SHORT[d.getMonth()])
    .replace('%m', _ssPad(d.getMonth() + 1))
    .replace('%d', _ssPad(d.getDate()))
    .replace('%e', String(d.getDate()).padStart(2, ' '))
    .replace('%Y', String(d.getFullYear()))
    .replace('%y', String(d.getFullYear()).slice(-2));
}

function _ssEscape(str) {
  return String(str).replace(/[&<>"]/g, function (c) {
    return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]);
  });
}

function _ssBuildInventoryBadge(inv) {
  if (!inv) {
    return '';
  }

  if (inv.inventory_management === 'shopify') {
    if (inv.inventory_quantity > 0) {
      return '<span class="stock-status-badge stock-status-badge--in-stock">Availability: In Stock</span>';
    }
    if (inv.inventory_policy === 'continue') {
      return '<span class="stock-status-badge stock-status-badge--backorder">Availability: <b>Backorder</b></span>';
    }
    if (inv.inventory_quantity == null) {
      return inv.available === false
        ? '<span class="stock-status-badge stock-status-badge--out-of-stock">Out Of Stock</span>'
        : '<span class="stock-status-badge stock-status-badge--in-stock">Availability: In Stock</span>';
    }
    return '<span class="stock-status-badge stock-status-badge--out-of-stock">Out Of Stock</span>';
  }

  if (inv.inventory_management == null || inv.inventory_management === '') {
    return '<span class="stock-status-badge stock-status-badge--in-stock">Availability: In Stock</span>';
  }

  if (inv.available === true) {
    return '<span class="stock-status-badge stock-status-badge--in-stock">Availability: In Stock</span>';
  }
  if (inv.available === false) {
    return '<span class="stock-status-badge stock-status-badge--out-of-stock">Out Of Stock</span>';
  }

  if (inv.inventory_quantity !== null) {
    if (inv.inventory_quantity > 0) {
      return '<span class="stock-status-badge stock-status-badge--in-stock">Availability: In Stock</span>';
    }
    if (inv.inventory_policy === 'continue') {
      return '<span class="stock-status-badge stock-status-badge--backorder">Availability: <b>Backorder</b></span>';
    }
    return '<span class="stock-status-badge stock-status-badge--out-of-stock">Out Of Stock</span>';
  }

  if (inv.inventory_management === null) {
    return '<span class="stock-status-badge stock-status-badge--in-stock">Availability: In Stock</span>';
  }

  return '';
}

function _ssBuildBadge(statusRaw, dateStr, qty) {
  if (!statusRaw) {
    return '';
  }

  var status = statusRaw.toLowerCase().trim();
  var dateFormat = '%B %d, %Y';

  if (status === 'on sale')
    return '<span class="stock-status-badge stock-status-badge--on-sale"><b>On Sale</b></span>';

  if (status === 'availability: backorder')
    return '<span class="stock-status-badge stock-status-badge--backorder">Availability: <b>Backorder</b></span>';

  if (status.includes('product will be available on')) {
    if (statusRaw.includes('{expected_date}')) {
      var dateLabel = '';
      if (dateStr) {
        var exp = new Date(dateStr + 'T00:00:00Z').getTime();
        var isExpired = exp <= Date.now();
        if (!isExpired) {
          dateLabel = _ssFormatDate(dateStr, dateFormat);
        }
      }
      var displayText = dateLabel ? statusRaw.replace('{expected_date}', dateLabel) : 'Coming Soon';
      return '<span class="stock-status-badge stock-status-badge--coming-soon">' + _ssEscape(displayText) + '</span>';
    }
    return '<span class="stock-status-badge stock-status-badge--coming-soon">' + _ssEscape(statusRaw) + '</span>';
  }

  if (status.includes('will be available {day-after-tomorrow}'))
    return '<span class="stock-status-badge stock-status-badge--coming-soon">Will be available ' + _ssOffsetDate(2, dateFormat) + '</span>';

  if (status === 'availability: special order')
    return '<span class="stock-status-badge stock-status-badge--special-order">Availability: <b>Special Order</b></span>';

  if (status.includes('drop ship'))
    return '<span class="stock-status-badge stock-status-badge--drop-ship">Availability: <b>Drop Ship</b> **LEAD TIME</span>';

  if (status === 'condition: used')
    return '<span class="stock-status-badge stock-status-badge--condition-used">Condition: Used</span>';

  if (status === 'availability: in stock')
    return '<span class="stock-status-badge stock-status-badge--in-stock">Availability: In Stock</span>';

  if (status === 'downloadable product')
    return '<span class="stock-status-badge stock-status-badge--downloadable">Downloadable Product</span>';

  if (status === 'discontinued')
    return '<span class="stock-status-badge stock-status-badge--discontinued">Discontinued</span>';

  if (status === 'out of stock')
    return '<span class="stock-status-badge stock-status-badge--out-of-stock">Out Of Stock</span>';

  if (status === 'open box')
    return '<span class="stock-status-badge stock-status-badge--open-box">Open Box</span>';

  if (statusRaw.includes('{qty}')) {
    var resolvedQty = (qty != null && !isNaN(Number(qty))) ? Number(qty) : 0;
    if (resolvedQty > 0) {
      var qtyText = statusRaw.replace('{qty}', resolvedQty);
      return '<span class="stock-status-badge stock-status-badge--low-stock">' + _ssEscape(qtyText) + '</span>';
    }
    return '';
  }

  return '<span class="stock-status-badge stock-status-badge--custom">' + _ssEscape(statusRaw) + '</span>';
}

function _injectStockStatusFromCache() {
  var showInCards = window.themeSettings && window.themeSettings.stockStatusShowInCards;
  if (showInCards === false) {
    return;
  }

  var hasStatus    = Object.keys(_stockStatusByHandle).length > 0;
  var hasInventory = Object.keys(_inventoryByHandle).length > 0;
  if (!hasStatus && !hasInventory) return;

  var items = document.querySelectorAll(_algoliaProductCardSelector());

  items.forEach(function (item) {
    if (item.querySelector('.ais-hit--stock-status-wrapper')) {
      return;
    }

    var link = item.querySelector('a[href*="/products/"]');
    if (!link) {
      return;
    }

    var match = (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    if (!match) {
      return;
    }

    var handle = match[1];
    var statusRaw = _stockStatusByHandle[handle] || null;
    var dateStr   = _stockDateByHandle[handle]   || null;

    var invData = _inventoryByHandle[handle] || null;
    var qty     = invData ? invData.inventory_quantity : null;

    var badgeHTML = _ssBuildBadge(statusRaw, dateStr, qty);

    if (!badgeHTML) {
      badgeHTML = _ssBuildInventoryBadge(_inventoryByHandle[handle] || null);
    }

    if (!badgeHTML) {
      return;
    }

    var wrapper = document.createElement('div');
    wrapper.className = 'ais-hit--stock-status-wrapper stock-status-wrapper';
    wrapper.setAttribute('data-handle', handle);
    wrapper.innerHTML = badgeHTML;

    var container = item.querySelector('.ais-hit--details') || item.querySelector('.ais-hit') ||
      item.querySelector('.card-information') || item.querySelector('.card-wrapper') || item;
    container.appendChild(wrapper);
  });
}

function _injectKlaviyoReviews() {
  var items = document.querySelectorAll(_algoliaProductCardSelector());
  var injected = 0;

  items.forEach(function (item) {
    var link = item.querySelector('a[href*="/products/"]');
    if (!link) { return; }

    var match = (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    if (!match) { return; }

    var handle = match[1];
    var pData = _productDataByHandle[handle] || {};
    var inferredId = _normalizeShopifyProductId(
      pData.id || item.getAttribute('data-product-id') || item.getAttribute('data-id') || ''
    );
    if (!inferredId) {
      var idFromDataset = item.dataset && (item.dataset.productId || item.dataset.id);
      inferredId = _normalizeShopifyProductId(idFromDataset || '');
    }

    var existing = item.querySelector('.klaviyo-star-rating-widget');
    if (existing) {
      if (!existing.getAttribute('data-id') && inferredId) {
        existing.setAttribute('data-id',            inferredId);
        existing.setAttribute('data-product-title', pData.title       || '');
        existing.setAttribute('data-product-type',  pData.productType || '');
        injected++;
      }
      _ensureKlaviyoShopifyProductIdForRecommend(handle, item);
      return;
    }

    var widget = document.createElement('span');
    widget.className = 'klaviyo-star-rating-widget no-count-text';
    if (inferredId) {
      widget.setAttribute('data-id', inferredId);
    }
    widget.setAttribute('data-product-title', pData.title       || '');
    widget.setAttribute('data-product-type',  pData.productType || '');

    var container = item.querySelector('.ais-hit--details') || item.querySelector('.ais-hit') ||
      item.querySelector('.card-information') || item;

    var priceEl = container.querySelector('.ais-hit--price, [class*="hit--price"], [class*="hit-price"], .price');
    var nameEl  = container.querySelector('.ais-hit--title, [class*="hit--title"], [class*="hit-name"], .card__heading');

    if (priceEl) {
      priceEl.parentNode.insertBefore(widget, priceEl);
    } else if (nameEl) {
      nameEl.insertAdjacentElement('afterend', widget);
    } else {
      container.appendChild(widget);
    }
    injected++;
    _ensureKlaviyoShopifyProductIdForRecommend(handle, item);
  });

  if (injected > 0) {
    _triggerKlaviyoRescan();
  }
}

var _klaviyoRescanTimer = null;
var _klaviyoRetryTimer = null;
var _klaviyoRetryAttempts = 0;
var _klaviyoReviewsModuleInjected = false;
var _klaviyoRescanInFlight = false;

function _getKlaviyoPublicKeyFromDom() {
  var scripts = document.getElementsByTagName('script');
  for (var i = 0; i < scripts.length; i++) {
    var src = scripts[i].src || '';
    if (!src || src.toLowerCase().indexOf('klaviyo') === -1) continue;
    var m = src.match(/\/onsite\/js\/([a-zA-Z0-9]{5,14})\/klaviyo\.js/i);
    if (m && m[1]) return m[1];
  }
  if (window.themeSettings && window.themeSettings.klaviyoPublicApiKey) {
    return String(window.themeSettings.klaviyoPublicApiKey).trim();
  }
  return '';
}

function _klaviyoReviewsModuleUrlPresent() {
  var scripts = document.querySelectorAll('script[src*="klaviyo"]');
  for (var i = 0; i < scripts.length; i++) {
    var s = scripts[i].src || '';
    if (s.indexOf('module=reviews') !== -1 || s.indexOf('module%3Dreviews') !== -1) return true;
  }
  return false;
}

function _hasPendingKlaviyoWidgets() {
  return Array.from(document.querySelectorAll('.klaviyo-star-rating-widget')).some(function (el) {
    return !_klaviyoWidgetHasRendered(el);
  });
}

function _renderKlaviyoWidgetsCore() {
  if (!_hasPendingKlaviyoWidgets()) return;

  if (window.klaviyo && typeof window.klaviyo.push === 'function') {
    try { window.klaviyo.push(['render']); } catch (e) {}
  }

  if (window.KlaviyoReviews && typeof window.KlaviyoReviews.init === 'function') {
    try { window.KlaviyoReviews.init(); } catch (e) {}
  }
  if (window.KlaviyoReviews && typeof window.KlaviyoReviews.render === 'function') {
    try { window.KlaviyoReviews.render(); } catch (e) {}
  }
  if (window.KlaviyoReviews && typeof window.KlaviyoReviews.refresh === 'function') {
    try { window.KlaviyoReviews.refresh(); } catch (e) {}
  }

  document.dispatchEvent(new CustomEvent('klaviyo:render'));
  window.dispatchEvent(new CustomEvent('klaviyo:render'));
}

function _renderKlaviyoWidgets() {
  var hasStars = !!document.querySelector('.klaviyo-star-rating-widget');
  var key = _getKlaviyoPublicKeyFromDom();
  if (
    hasStars &&
    key &&
    !window.KlaviyoReviews &&
    !_klaviyoReviewsModuleUrlPresent() &&
    !_klaviyoReviewsModuleInjected
  ) {
    _klaviyoReviewsModuleInjected = true;
    var s = document.createElement('script');
    s.async = true;
    s.setAttribute('data-kingsley-algolia-klaviyo-reviews', '1');
    s.src = 'https://static.klaviyo.com/onsite/js/' + encodeURIComponent(key) + '/klaviyo.js?module=reviews';
    s.onload = function () {
      _renderKlaviyoWidgetsCore();
    };
    s.onerror = function () {
      _klaviyoReviewsModuleInjected = false;
      _renderKlaviyoWidgetsCore();
    };
    document.head.appendChild(s);
    return;
  }

  _renderKlaviyoWidgetsCore();
}

function _scheduleKlaviyoRetry() {
  clearTimeout(_klaviyoRetryTimer);
  if (!_hasPendingKlaviyoWidgets()) {
    _klaviyoRetryAttempts = 0;
    return;
  }
  if (_klaviyoRetryAttempts >= 16) {
    _klaviyoRetryAttempts = 0;
    return;
  }

  _klaviyoRetryAttempts += 1;
  _klaviyoRetryTimer = setTimeout(function () {
    _renderKlaviyoWidgets();
    _scheduleKlaviyoRetry();
  }, 400);
}

function _triggerKlaviyoRescan() {
  if (_klaviyoRescanInFlight) return;
  if (!_hasPendingKlaviyoWidgets()) return;

  _klaviyoRescanInFlight = true;
  clearTimeout(_klaviyoRescanTimer);
  _klaviyoRescanTimer = setTimeout(function () {
    _klaviyoRetryAttempts = 0;
    _renderKlaviyoWidgets();
    setTimeout(_renderKlaviyoWidgets, 300);
    setTimeout(function () {
      _renderKlaviyoWidgets();
      _klaviyoRescanInFlight = false;
      _scheduleKlaviyoRetry();
    }, 900);
  }, 150);
}

function _isInventoryAvailable(inv) {
  if (!inv) return true;
  if (inv.inventory_management === 'shopify') {
    if (inv.inventory_quantity == null) {
      return inv.available !== false;
    }
    return inv.inventory_quantity > 0 || inv.inventory_policy === 'continue';
  }

  if (inv.inventory_management == null || inv.inventory_management === '') {
    return true;
  }
  return inv.available !== false &&
         (inv.inventory_quantity == null || inv.inventory_quantity > 0 || inv.inventory_policy === 'continue');
}

function _buildAtcButton(handle, pData, productUrl) {
  var inv = _inventoryByHandle[handle] || null;
  var variantCount = _variantCountByHandle[handle] || 1;
  var hasRealOptions = _hasRealOptionsByHandle[handle] || false;
  var hasVariants = hasRealOptions;

  var variantId = pData.variantId || '';

  var isAvailable = inv ? _isInventoryAvailable(inv) : true;

  var btn = document.createElement('a');
  btn.className = 'algolia-atc-btn button button--full-width button--secondary';
  btn.setAttribute('data-handle', handle);

  if (!hasVariants && !_liveInvConfirmedHandles[handle]) {
    btn.href = '#';
    btn.textContent = 'Add to Cart';
    btn.classList.add('algolia-atc-btn--inv-pending');
    btn.setAttribute('data-atc-inv-pending', 'true');
    btn.setAttribute('disabled', 'disabled');
    btn.setAttribute('aria-disabled', 'true');
    btn.setAttribute('aria-busy', 'true');
    btn.setAttribute('aria-label', 'Checking availability for ' + (pData.title || ''));
    btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); });
    _reconcileAtcWithLiveInventory(handle);
    return btn;
  }

  if (!inv) {
    btn.setAttribute('data-atc-inv-pending', 'true');
  }

  if (hasVariants) {
    btn.href = productUrl;
    btn.textContent = 'Choose Options';
    btn.setAttribute('aria-label', 'Choose options for ' + (pData.title || ''));
  } else if (!variantId) {
    if (hasRealOptions) {
      btn.href = productUrl;
      btn.textContent = 'Choose Options';
      btn.setAttribute('aria-label', 'Choose options for ' + (pData.title || ''));
    } else if (!isAvailable) {
      btn.href = '#';
      btn.textContent = 'Sold Out';
      btn.classList.add('algolia-atc-btn--sold-out');
      btn.setAttribute('disabled', 'disabled');
      btn.setAttribute('aria-disabled', 'true');
      btn.setAttribute('aria-label', 'Sold out: ' + (pData.title || ''));
    } else {
      btn.href = '#';
      btn.setAttribute('aria-label', 'Add to cart: ' + (pData.title || ''));
      btn.setAttribute('data-atc-resolve', 'true');
      btn.textContent = 'Add to Cart';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (btn.getAttribute('disabled')) return;

        var cachedData = _productDataByHandle[handle] || {};
        var vid = cachedData.variantId || '';
        if (vid) {
          _handleAtcClick(btn, vid, cachedData.minQty);
          return;
        }

        var originalText = btn.textContent;
        btn.textContent = 'Adding…';
        btn.setAttribute('disabled', 'disabled');
        btn.setAttribute('aria-disabled', 'true');

        _fetchShopifyProductJson(handle)
          .then(function (data) {
            var product = data && data.product;
            var variants = product && Array.isArray(product.variants) ? product.variants : [];
            var resolvedVariant = null;
            for (var vi = 0; vi < variants.length; vi++) {
              if (variants[vi].available) { resolvedVariant = variants[vi]; break; }
            }
            if (!resolvedVariant && variants.length > 0) resolvedVariant = variants[0];
            if (!resolvedVariant || !resolvedVariant.id) {
              window.location.href = productUrl;
              return;
            }

            var resolvedId = String(resolvedVariant.id);

            if (_productDataByHandle[handle]) {
              _productDataByHandle[handle].variantId = resolvedId;
            }

            btn.removeAttribute('disabled');
            btn.removeAttribute('aria-disabled');
            btn.textContent = originalText;
            _handleAtcClick(btn, resolvedId, (_productDataByHandle[handle] || {}).minQty);
          })
          .catch(function (err) {
            window.location.href = productUrl;
          });
      });
    }
  } else {
    btn.href = '#';
    if (!isAvailable) {
      btn.textContent = 'Sold Out';
      btn.classList.add('algolia-atc-btn--sold-out');
      btn.setAttribute('disabled', 'disabled');
      btn.setAttribute('aria-disabled', 'true');
    } else {
      btn.textContent = 'Add to Cart';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (btn.getAttribute('disabled')) return;
        var h = btn.getAttribute('data-handle');
        var cachedData = _productDataByHandle[h] || {};
        var vid = cachedData.variantId || '';
        if (!vid) {
          window.location.href = productUrl;
          return;
        }
        _handleAtcClick(btn, vid, cachedData.minQty);
      });
    }
  }
  return btn;
}

function _parseMinQty(raw) {
  var n = parseInt(raw, 10);
  if (isNaN(n) || n < 1) return 1;
  return n;
}

function _getSectionInnerHTML(html, selector) {
  if (!html) return '';
  var doc = new DOMParser().parseFromString(html, 'text/html');
  var el = doc.querySelector(selector || '.shopify-section');
  return el ? el.innerHTML : '';
}

function _applyCartDrawerSection(drawerHtml) {
  var cartDrawer = document.querySelector('cart-drawer');
  if (!drawerHtml || !cartDrawer) return cartDrawer;

  var doc = new DOMParser().parseFromString(drawerHtml, 'text/html');
  var refreshedDrawer = doc.querySelector('cart-drawer');
  if (refreshedDrawer) {
    cartDrawer.className = refreshedDrawer.className;
    cartDrawer.innerHTML = refreshedDrawer.innerHTML;
  }

  if (cartDrawer.classList.contains('is-empty')) {
    cartDrawer.classList.remove('is-empty');
  }

  var drawerInner = cartDrawer.querySelector('.drawer__inner');
  if (drawerInner && drawerInner.classList.contains('is-empty')) {
    drawerInner.classList.remove('is-empty');
  }

  return cartDrawer;
}

function _applyCartIconBubbleSection(bubbleHtml) {
  if (!bubbleHtml) return;
  var liveBubble = document.getElementById('cart-icon-bubble');
  if (!liveBubble) return;
  liveBubble.innerHTML = _getSectionInnerHTML(bubbleHtml, '.shopify-section');
}

function _applyCartSections(sections) {
  if (!sections) return null;
  var cartDrawer = _applyCartDrawerSection(sections['cart-drawer']);
  _applyCartIconBubbleSection(sections['cart-icon-bubble']);
  return cartDrawer;
}

function _fetchCartSections() {
  var sectionsPath = (window.routes && window.routes.cart_url) || '/cart';
  var url = sectionsPath + '?sections=cart-drawer,cart-icon-bubble';
  return fetch(url)
    .then(function (r) { return r.json(); })
    .then(function (sections) {
      return _applyCartSections(sections);
    });
}

function _openCartDrawer(cartDrawer) {
  if (!cartDrawer) cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer) return;

  if (typeof cartDrawer.open === 'function') {
    try { cartDrawer.open(); } catch (err) {}
  }
  document.dispatchEvent(new CustomEvent('cart-drawer:open', { bubbles: true }));
  window.dispatchEvent(new CustomEvent('cart-drawer:open'));
}

function _publishCartUpdateEvents(cart) {
  if (!cart) return;

  var cartUpdateEvents = [
    'cart:refresh', 'cart:updated', 'cart:change',
    'theme:cart:open', 'theme:cart:update'
  ];
  cartUpdateEvents.forEach(function (evtName) {
    document.dispatchEvent(new CustomEvent(evtName, { detail: { cart: cart }, bubbles: true }));
  });

  if (typeof window.publish === 'function') {
    ['cart:refresh', 'cart:updated'].forEach(function (key) {
      try { window.publish(key, { cart: cart }); } catch (err) {}
    });
  }
}

function _handleAtcClick(btn, variantId, minQty) {
  if (!variantId) { return; }

  var numericId = Number(variantId);
  if (!numericId || isNaN(numericId)) {
    return;
  }

  var quantity = _parseMinQty(minQty);

  var originalText = btn.textContent;
  btn.textContent = 'Adding…';
  btn.setAttribute('disabled', 'disabled');
  btn.setAttribute('aria-disabled', 'true');
  btn.classList.add('algolia-atc-btn--loading');

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: JSON.stringify({
      id: numericId,
      quantity: quantity,
      sections: 'cart-drawer,cart-icon-bubble',
      sections_url: window.location.pathname
    })
  })
  .then(function (res) {
    return res.json().then(function (data) {
      return { ok: res.ok, status: res.status, data: data };
    });
  })
  .then(function (result) {
    var data = result.data;
    if (!result.ok || (data.status && data.status >= 400)) {
      btn.textContent = 'Error';
      btn.classList.remove('algolia-atc-btn--loading');
      btn.classList.add('algolia-atc-btn--error');
      setTimeout(function () {
        btn.textContent = originalText;
        btn.removeAttribute('disabled');
        btn.removeAttribute('aria-disabled');
        btn.classList.remove('algolia-atc-btn--error');
      }, 2500);
      return;
    }

    btn.textContent = 'Added!';
    btn.classList.remove('algolia-atc-btn--loading');
    btn.classList.add('algolia-atc-btn--added');

    var sectionsPromise = data.sections
      ? Promise.resolve(_applyCartSections(data.sections))
      : _fetchCartSections();

    sectionsPromise
      .then(function (cartDrawer) {
        return fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            _publishCartUpdateEvents(cart);
            return cartDrawer;
          });
      })
      .catch(function () {
        return _fetchCartSections();
      })
      .then(function (cartDrawer) {
        _openCartDrawer(cartDrawer);
      });

    setTimeout(function () {
      btn.textContent = originalText;
      btn.removeAttribute('disabled');
      btn.removeAttribute('aria-disabled');
      btn.classList.remove('algolia-atc-btn--added');
    }, 2500);
  })
  .catch(function (err) {
    btn.textContent = 'Error';
    btn.classList.remove('algolia-atc-btn--loading');
    btn.classList.add('algolia-atc-btn--error');
    setTimeout(function () {
      btn.textContent = originalText;
      btn.removeAttribute('disabled');
      btn.removeAttribute('aria-disabled');
      btn.classList.remove('algolia-atc-btn--error');
    }, 2500);
  });
}

function _injectCompareButtons() {
  _ensureControlNavGuard();
  var showWishlist = _isWishlistOnAlgoliaPlpEnabled();
  var showCompare = _isCompareOnAlgoliaPlpEnabled();
  var items = document.querySelectorAll(_algoliaProductCardSelector());
  var freshlyBuilt = 0;

  _applyAlgoliaWishlistPlpVisibility();

  if (!showWishlist) {
    _purgeAlgoliaWishlistIcons();
  }

  if (!showWishlist && !showCompare) {
    document.querySelectorAll('.compare-wishlist--algolia-hooks').forEach(function (el) {
      el.remove();
    });
  }

  items.forEach(function (item) {
    var link = item.querySelector('a[href*="/products/"]');
    if (!link) { return; }

    var match = (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    if (!match) { return; }

    var handle = match[1];
    var pData = _productDataByHandle[handle] || {};
    var productUrl = location.protocol + '//' + location.host + '/products/' + handle;
    var container = item;

    var staleCardBottom = item.querySelector('.algolia-card-bottom');
    var staleAtcBtn = staleCardBottom ? staleCardBottom.querySelector('.algolia-atc-btn') : null;
    if (staleAtcBtn && staleAtcBtn.getAttribute('data-handle') !== handle) {
      if (staleCardBottom.parentNode) staleCardBottom.parentNode.removeChild(staleCardBottom);
      var mismatchedWrapper = item.querySelector('.compare-wishlist--algolia-hooks');
      if (mismatchedWrapper && mismatchedWrapper.parentNode && !staleCardBottom.contains(mismatchedWrapper)) {
        mismatchedWrapper.parentNode.removeChild(mismatchedWrapper);
      }
    }

    var existingWrapper = item.querySelector('.compare-wishlist--algolia-hooks');
    if (existingWrapper) {
      _syncAlgoliaWishlistCompareWrapper(existingWrapper, handle, pData, productUrl);

      var existingCardBottom = item.querySelector('.algolia-card-bottom');
      var existingAtcBtn = existingCardBottom ? existingCardBottom.querySelector('.algolia-atc-btn') : null;
      if (existingAtcBtn && existingAtcBtn.getAttribute('data-handle') === handle) {
        var currentText = existingAtcBtn.textContent;
        var hasRealOptionsNow = _hasRealOptionsByHandle[handle] || false;
        var variantIdNow = pData.variantId || '';
        var wasFallback = existingAtcBtn.hasAttribute('data-atc-resolve') || existingAtcBtn.hasAttribute('data-atc-fallback');

        var invNow = _inventoryByHandle[handle] || null;
        var invPending = existingAtcBtn.hasAttribute('data-atc-inv-pending');
        var liveConfirmed = !!_liveInvConfirmedHandles[handle];
        var soldOutNow = invNow ? !_isInventoryAvailable(invNow) : false;
        var showingSoldOut = existingAtcBtn.classList.contains('algolia-atc-btn--sold-out');
        var stockMismatch =
          (invPending && liveConfirmed) ||
          (!invPending && !!invNow && soldOutNow !== showingSoldOut);

        var needsUpdate = (currentText === 'Choose Options' && !hasRealOptionsNow) ||
                          (wasFallback && hasRealOptionsNow) ||
                          stockMismatch;
        if (needsUpdate) {
          var updatedBtn = _buildAtcButton(handle, pData, productUrl);
          existingAtcBtn.parentNode.replaceChild(updatedBtn, existingAtcBtn);
        } else if (invPending && !liveConfirmed) {
          _reconcileAtcWithLiveInventory(handle);
        }
      }

      if (existingCardBottom && (existingCardBottom.parentNode !== container || container.lastElementChild !== existingCardBottom)) {
        container.appendChild(existingCardBottom);
      }
      return;
    }

    if (!showWishlist && !showCompare) {
      return;
    }

    var wrapper = document.createElement('div');
    wrapper.className = 'compare-wishlist compare-wishlist--algolia-hooks';
    ['mousedown', 'mouseup', 'touchstart', 'pointerdown'].forEach(function (evtName) {
      wrapper.addEventListener(evtName, function (e) {
        var compareTarget = e.target.closest('.sp-compare-custom-collection');
        if (!compareTarget) return;
        if (evtName === 'mousedown' || evtName === 'mouseup') {
          e.preventDefault();
        }
        e.stopPropagation();
      });
    });

    wrapper.addEventListener('click', function (e) {
      if (e._wlhSynthetic) return;
      var compareTarget = e.target.closest('.sp-compare-custom-collection');
      var wishlistTarget = e.target.closest('.wishlist-hero-custom-button');
      if (!compareTarget && !wishlistTarget) return;

      if (compareTarget) {
        e.stopPropagation();
        setTimeout(function () {
          if (typeof window.compareGridRender === 'function') {
            try { window.compareGridRender(); } catch (err) {}
          }
          if (typeof window.equateAppGetComparedData === 'function') {
            try { window.equateAppGetComparedData(); } catch (err) {}
          }
        }, 0);
      }
    });

    _appendAlgoliaWishlistButton(wrapper, handle, pData, productUrl);
    _appendAlgoliaCompareButton(wrapper, handle);

    var atcBtn = _buildAtcButton(handle, pData, productUrl);

    var cardBottom = document.createElement('div');
    cardBottom.className = 'algolia-card-bottom';
    cardBottom.appendChild(atcBtn);
    cardBottom.appendChild(wrapper);

    container.appendChild(cardBottom);
    freshlyBuilt++;
  });

  if (freshlyBuilt > 0) {
    if (showWishlist) _triggerWishlistHeroRescan();
    if (showCompare) _triggerEquateRescan();
  }
}

var _wlhRescanTimer = null;
function _triggerWishlistHeroRescan() {
  if (!_isWishlistOnAlgoliaPlpEnabled()) {
    _applyAlgoliaWishlistPlpVisibility();
    return;
  }
  clearTimeout(_wlhRescanTimer);
  _wlhRescanTimer = setTimeout(function () {
    if (!_isWishlistOnAlgoliaPlpEnabled()) {
      _applyAlgoliaWishlistPlpVisibility();
      return;
    }
    var wlhNodes = document.querySelectorAll('.compare-wishlist--algolia-hooks .wishlist-hero-custom-button');
    wlhNodes.forEach(function (node) {
      var clone = node.cloneNode(true);
      node.parentNode.replaceChild(clone, node);
    });

    var sdk = window.WishListHero_SDK || window.WishlistHero || window.wlh || null;
    if (sdk && typeof sdk.InitializeAddToWishListButton === 'function') {
      document.querySelectorAll('.compare-wishlist--algolia-hooks .wishlist-hero-custom-button').forEach(function (btn) {
        try { sdk.InitializeAddToWishListButton(btn); } catch (e) {}
      });
      return;
    }
    if (sdk) {
      if (typeof sdk.init   === 'function') { try { sdk.init();   return; } catch (e) {} }
      if (typeof sdk.render === 'function') { try { sdk.render(); return; } catch (e) {} }
    }
    document.dispatchEvent(new CustomEvent('wishlist-hero:init'));
    document.dispatchEvent(new CustomEvent('wishlisthero:init'));
    window.dispatchEvent(new CustomEvent('wishlist-hero:refresh'));

    setTimeout(function () {
      if (sdk && typeof sdk.InitializeAddToWishListButton === 'function') {
        document.querySelectorAll('.compare-wishlist--algolia-hooks .wishlist-hero-custom-button').forEach(function (btn) {
          try { sdk.InitializeAddToWishListButton(btn); } catch (e) {}
        });
      }
      document.dispatchEvent(new CustomEvent('wishlist-hero:init'));
      window.dispatchEvent(new CustomEvent('wishlist-hero:refresh'));
    }, 300);
  }, 100);
}

var _equateRescanTimer = null;
function _triggerEquateRescan() {
  if (_equateRescanTimer) return;
  _equateRescanTimer = setTimeout(function () {
    _equateRescanTimer = null;
    _runEquateRescan();
  }, 250);
}

function _runEquateRescan() {
  function _callFunctionGlobal(name, args) {
    if (typeof window[name] === 'function') {
      try {
        window[name].apply(window, args || []);
      } catch (e) {}
    }
  }

  try {
    if (window.SPRCompare) {
      if (typeof window.SPRCompare.init === 'function') { window.SPRCompare.init(); }
      if (typeof window.SPRCompare.render === 'function') { window.SPRCompare.render(); }
      if (typeof window.SPRCompare.refresh === 'function') { window.SPRCompare.refresh(); }
    }
    if (window.EquateCompare) {
      if (typeof window.EquateCompare.init === 'function') { window.EquateCompare.init(); }
      if (typeof window.EquateCompare.render === 'function') { window.EquateCompare.render(); }
    }
    if (window.SPE && typeof window.SPE.init === 'function') { window.SPE.init(); }
  } catch (e) {}

  _callFunctionGlobal('isEquateAppLoaded');
  _callFunctionGlobal('compareGridRender');
  _callFunctionGlobal('equateAppGetComparedData');

  ['equate:init', 'equate:refresh', 'compare:init', 'compare:refresh', 'page:updated'].forEach(function (evtName) {
    window.dispatchEvent(new CustomEvent(evtName));
    document.dispatchEvent(new CustomEvent(evtName));
  });
  document.dispatchEvent(new CustomEvent('shopify:section:load', { detail: { sectionId: 'algolia-shopify-instantsearch' } }));

  var eqNodes = document.querySelectorAll('.compare-wishlist--algolia-hooks .sp-compare-custom-collection');
  eqNodes.forEach(function (node) {
    var clone = node.cloneNode(true);
    node.parentNode.replaceChild(clone, node);
  });

  setTimeout(function () {
    _callFunctionGlobal('compareGridRender');
    _callFunctionGlobal('equateAppGetComparedData');
    ['equate:init', 'equate:refresh', 'compare:init', 'compare:refresh', 'page:updated'].forEach(function (evtName) {
      window.dispatchEvent(new CustomEvent(evtName));
      document.dispatchEvent(new CustomEvent(evtName));
    });
    document.dispatchEvent(new CustomEvent('shopify:section:load', { detail: { sectionId: 'algolia-shopify-instantsearch' } }));
  }, 250);

  setTimeout(function () {
    _callFunctionGlobal('compareGridRender');
    _callFunctionGlobal('equateAppGetComparedData');
    ['equate:init', 'equate:refresh', 'compare:init', 'compare:refresh', 'page:updated'].forEach(function (evtName) {
      window.dispatchEvent(new CustomEvent(evtName));
      document.dispatchEvent(new CustomEvent(evtName));
    });
    document.dispatchEvent(new CustomEvent('shopify:section:load', { detail: { sectionId: 'algolia-shopify-instantsearch' } }));
  }, 900);
}

function _algoliaAutocompleteItemSelector() {
  return '.aa-Source[data-autocomplete-source-id="products"] .aa-Item';
}

/** Swap a single card/item's thumbnail to the cached product_image, keyed by its product link. */
function _swapProductImageForItem(item) {
  var link = item.querySelector('a[href*="/products/"]');
  if (!link) return;

  var match = (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
  if (!match) return;

  var productImage = _productImageByHandle[match[1]];
  if (!productImage) return;

  var img = item.querySelector('img');
  if (!img) return;
  if (img.getAttribute('data-kingsley-product-image') === productImage) return;

  img.setAttribute('data-kingsley-product-image', productImage);
  img.setAttribute('src', productImage);
  if (img.hasAttribute('srcset')) img.removeAttribute('srcset');
}

var _kingsleyImageLinkClass = 'ais-hit--picture-link';

function _fixImageLinkUrlsForItem(item) {
  var titleLink = item.querySelector('.ais-hit--title a');
  if (!titleLink) return;

  var titleHref = titleLink.getAttribute('href');
  if (!titleHref) return;

  var img = item.querySelector('img.ais-hit--picture');
  if (!img) return;

  var existingLink = img.closest('a.' + _kingsleyImageLinkClass);
  if (existingLink) {
    if (existingLink.getAttribute('href') !== titleHref) {
      existingLink.setAttribute('href', titleHref);
    }
    return;
  }

  var link = document.createElement('a');
  link.className = _kingsleyImageLinkClass;
  link.setAttribute('href', titleHref);
  link.setAttribute('aria-hidden', 'true');
  link.setAttribute('tabindex', '-1');

  link.addEventListener('click', function (e) {
    e.stopPropagation();
  });

  img.parentNode.insertBefore(link, img);
  link.appendChild(img);
}

function _fixImageLinkUrls() {
  document.querySelectorAll(_algoliaProductCardSelector()).forEach(_fixImageLinkUrlsForItem);
}

(function () {
  function _isModifiedOpen(e) {
    return e.button === 1 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey;
  }

  function _onCapturedClick(e) {
    if (!_isModifiedOpen(e)) return;
    var target = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!target) return;
    var href = target.getAttribute('href') || '';
    if (href.indexOf('/products/') === -1) return;
    if (!target.closest('.ais-hit, .ais-Hits-item, [id^="alg-recommend-wrapper"], .aa-Item')) return;

    e.stopImmediatePropagation();
  }

  ['click', 'auxclick', 'mousedown', 'pointerdown'].forEach(function (evtName) {
    document.addEventListener(evtName, _onCapturedClick, true);
  });
}());

function _injectProductImagesFromCache() {
  if (!Object.keys(_productImageByHandle).length) return;

  document.querySelectorAll(_algoliaProductCardSelector()).forEach(_swapProductImageForItem);
  document.querySelectorAll(_algoliaAutocompleteItemSelector()).forEach(_swapProductImageForItem);
}

function _injectLabelsFromCache() {
  if (!Object.keys(_labelCache).length && !Object.keys(_onSaleByHandle).length) return;

  document.querySelectorAll(_algoliaProductCardSelector()).forEach(function (item) {
    if (item.querySelector('.ais-hit--product-label-wrapper')) return;

    var link = item.querySelector('a[href*="/products/"]');
    if (!link) return;

    var match = (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    if (!match) return;

    var handle = match[1];
    var onSale = !!_onSaleByHandle[handle];
    var label = _labelCache[handle];

    if (!onSale && !label) return;

    var span = document.createElement('span');
    span.className = 'product-label__text';

    var wrapper = document.createElement('div');
    wrapper.className = 'ais-hit--product-label-wrapper';

    if (onSale) {
      span.textContent = 'Sale';
      wrapper.classList.add('product-label--on-sale');
      wrapper.setAttribute('aria-label', 'Sale');
    } else {
      span.textContent = label;
      wrapper.classList.add('product-label--' + _slugify(label));
      wrapper.setAttribute('aria-label', label);
    }

    wrapper.appendChild(span);

    var pictureEl = item.querySelector('.ais-hit--picture-link, .ais-hit--picture') ||
      item.querySelector('.card__media') ||
      item.querySelector('.card__inner');
    var injectTarget = null;

    if (pictureEl) {
      var tag = pictureEl.tagName.toLowerCase();
      if (tag === 'img' || tag === 'picture' || tag === 'source') {
        var par = pictureEl.parentElement;
        if (par) {
          par.style.setProperty('position', 'relative', 'important');
          injectTarget = par;
        }
      } else {
        pictureEl.style.setProperty('position', 'relative', 'important');
        injectTarget = pictureEl;
      }
    }

    if (!injectTarget) {
      injectTarget = item.querySelector('.ais-hit') || item.querySelector('.card-wrapper') || item;
    }

    injectTarget.insertAdjacentElement('afterbegin', wrapper);
  });
}

(function () {
  if (typeof window.fetch !== 'function') {
    return;
  }
  var _origFetch = window.fetch;
  window.fetch = function (resource, init) {
    var url = typeof resource === 'string' ? resource
            : (resource && resource.url ? resource.url : '');
    var promise = _origFetch.apply(this, arguments);
    if (url.indexOf('algolia') !== -1) {
      promise.then(function (response) {
        response.clone().json().then(function (data) {
          _processAlgoliaResponse(data);
          _demoteAlgoliaPlpTitleHeading();
          _scheduleInjectors();
        }).catch(function (e) {});
      }).catch(function (e) {});
    }
    return promise;
  };
}());

(function () {
  var _origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (typeof url === 'string' && url.indexOf('algolia') !== -1) {
      this._isAlgolia = true;
      this._algoliaUrl = url;
    }
    return _origOpen.apply(this, arguments);
  };

  var _origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this._isAlgolia) {
      var xhr = this;
      xhr.addEventListener('load', function () {
        if (xhr.status === 200) {
          try {
            var data = JSON.parse(xhr.responseText);
            _processAlgoliaResponse(data);
            _demoteAlgoliaPlpTitleHeading();
            _scheduleInjectors();
          } catch (e) {}
        }
      });
    }
    return _origSend.apply(this, arguments);
  };
}());

(function () {
  function _addedNodesSuggestCards(nodes) {
    return Array.from(nodes).some(function (n) {
      if (!n || n.nodeType !== 1) return false;
      if (n.classList && n.classList.contains('ais-Hits-item')) return true;
      if (n.classList && n.classList.contains('uic-HorizontalSlider-item') && _isRecommendSliderItem(n)) return true;
      if (n.id && n.id.indexOf('alg-recommend-wrapper') === 0 && n.querySelector &&
        n.querySelector('.uic-HorizontalSlider-item')) return true;
      if (n.classList && (n.classList.contains('aa-Panel') || n.classList.contains('aa-Item'))) return true;
      if (!n.querySelector) return false;
      if (n.querySelector('.ais-Hits-item')) return true;
      if (n.querySelector('.aa-Source[data-autocomplete-source-id="products"] .aa-Item')) return true;
      var rec = n.matches && n.matches('[id^="alg-recommend-wrapper"]') ? n : n.querySelector('[id^="alg-recommend-wrapper"]');
      return !!(rec && rec.querySelector('.uic-HorizontalSlider-item'));
    });
  }

  function _startObserver() {
    new MutationObserver(function (mutations) {
      var hasNewHits = mutations.some(function (m) {
        return _addedNodesSuggestCards(m.addedNodes);
      });
      if (hasNewHits) {
        _demoteAlgoliaPlpTitleHeading();
        _scheduleInjectors();
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', _startObserver);
  } else {
    _startObserver();
  }
}());

function _onWishlistHeroLifecycleEvent() {
  if (!_isWishlistOnAlgoliaPlpEnabled()) {
    _applyAlgoliaWishlistPlpVisibility();
  }
}

document.addEventListener('wishlist-hero:init', _onWishlistHeroLifecycleEvent);
document.addEventListener('wishlisthero:init', _onWishlistHeroLifecycleEvent);
window.addEventListener('wishlist-hero:refresh', _onWishlistHeroLifecycleEvent);
document.addEventListener('wishlist-hero-wishlist-sdk-ready', _onWishlistHeroLifecycleEvent);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', _scheduleAlgoliaWishlistPlpVisibility);
} else {
  _scheduleAlgoliaWishlistPlpVisibility();
}


function _shouldDemoteAlgoliaPlpTitleToH2() {
  if (document.body) {
    if (document.body.classList.contains('template-collection')) return true;
    if (document.body.classList.contains('template-search')) return false;
  }
  var path = (window.location && window.location.pathname) || '';
  if (path.indexOf('/search') === 0) return false;
  if (path.indexOf('/collections/') === 0) return true;
  return false;
}

function _demoteAlgoliaPlpTitleHeading() {
  if (!_shouldDemoteAlgoliaPlpTitleToH2()) return;
  document.querySelectorAll('h1.ais-h2').forEach(function (heading) {
    if (!heading.parentNode) return;
    var h2 = document.createElement('h2');
    Array.prototype.forEach.call(heading.attributes, function (attr) {
      h2.setAttribute(attr.name, attr.value);
    });
    while (heading.firstChild) {
      h2.appendChild(heading.firstChild);
    }
    heading.parentNode.replaceChild(h2, heading);
  });
}

/**
 * True when the shopper has active facet refinements (not the collection scope filter).
 * Prefers InstantSearch clear-refinements button state, then refinement chips / selected facets.
 */
function _kingsleyHasActivePlpFilters() {
  var clearBtn = document.querySelector(
    '.ais-page .ais-ClearRefinements-button, .ais-page .ais-clear-refinements--button, .ais-page .ais-clear-refinements-container button'
  );
  if (clearBtn) {
    var disabled =
      !!clearBtn.disabled ||
      clearBtn.getAttribute('disabled') != null ||
      clearBtn.classList.contains('ais-ClearRefinements-button--disabled') ||
      clearBtn.classList.contains('ais-clear-refinements--disabled');
    return !disabled;
  }

  if (
    document.querySelector('.ais-page .ais-CurrentRefinements-item') ||
    document.querySelector('.ais-page .ais-current-refined-values--item') ||
    document.querySelector('.ais-page .ais-current-refined-values-container a') ||
    document.querySelector('.ais-page .ais-current-refined-values-container .ais-current-refined-values--link')
  ) {
    return true;
  }

  if (document.querySelector('#rating-filter-container .algolia-star-rating-button.active')) {
    return true;
  }

  if (
    document.querySelector('.ais-page .ais-RefinementList-item--selected') ||
    document.querySelector('.ais-page .ais-Menu-item--selected') ||
    document.querySelector('.ais-page .ais-HierarchicalMenu-item--selected') ||
    document.querySelector('.ais-page .ais-ToggleRefinement--selected') ||
    document.querySelector('.ais-page .ais-NumericMenu-item--selected')
  ) {
    return true;
  }

  return false;
}

/**
 * Empty-state helper links.
 * Always keep "changing your input" (clears the search box).
 * Only include "clearing the filters" when filters are actually applied.
 * Modes: both | query
 */
function _kingsleyPlpEmptyClearsMode(hasFilters) {
  return hasFilters ? 'both' : 'query';
}

function _kingsleyBuildNoResultClearsHtml(mode, labels) {
  var tryLabel = labels.tryLabel;
  var orLabel = labels.orLabel;
  var clearFiltersLabel = labels.clearFiltersLabel;
  var changeInputLabel = labels.changeInputLabel;

  var html = tryLabel + ' ';
  if (mode === 'both') {
    html +=
      '<a class="ais-hit-empty--clear-filters ais-link">' +
      clearFiltersLabel +
      '</a>' +
      ' ' +
      orLabel +
      ' ';
  }
  html +=
    '<a class="ais-hit-empty--clear-input ais-link">' +
    changeInputLabel +
    '</a>';
  return html;
}

function _syncAlgoliaNoResultClearsMessage() {
  var empty = document.querySelector('.ais-page .ais-hit-empty');
  if (!empty) return;

  var clears = empty.querySelector('.ais-hit-empty--clears');
  if (!clears) return;

  var mode = _kingsleyPlpEmptyClearsMode(_kingsleyHasActivePlpFilters());
  if (clears.getAttribute('data-kingsley-empty-mode') === mode) return;
  clears.setAttribute('data-kingsley-empty-mode', mode);

  var t = (window.algoliaShopify && window.algoliaShopify.translations) || {};
  var existingFilters = clears.querySelector('.ais-hit-empty--clear-filters');
  var existingInput = clears.querySelector('.ais-hit-empty--clear-input');
  var labels = {
    tryLabel: t.try || 'Try',
    orLabel: t.or || 'or',
    clearFiltersLabel:
      (existingFilters && existingFilters.textContent.trim()) ||
      t.clearFilters ||
      'clearing the filters',
    changeInputLabel:
      (existingInput && existingInput.textContent.trim()) ||
      t.changeInput ||
      'changing your input'
  };

  clears.style.display = '';
  clears.innerHTML = _kingsleyBuildNoResultClearsHtml(mode, labels);
}

(function () {
  var _headingObserverStarted = false;
  var _emptyClearsObserverStarted = false;

  function _startAlgoliaPlpHeadingWatcher() {
    if (!_shouldDemoteAlgoliaPlpTitleToH2()) return;
    _demoteAlgoliaPlpTitleHeading();
    if (_headingObserverStarted) return;
    _headingObserverStarted = true;
    new MutationObserver(_demoteAlgoliaPlpTitleHeading).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  function _startAlgoliaNoResultClearsWatcher() {
    _syncAlgoliaNoResultClearsMessage();
    if (_emptyClearsObserverStarted) return;
    _emptyClearsObserverStarted = true;

    var scheduled = 0;
    function scheduleSync() {
      if (scheduled) return;
      scheduled = window.requestAnimationFrame
        ? window.requestAnimationFrame(function () {
            scheduled = 0;
            _syncAlgoliaNoResultClearsMessage();
            _syncPlpSearchBarOpenState();
          })
        : setTimeout(function () {
            scheduled = 0;
            _syncAlgoliaNoResultClearsMessage();
            _syncPlpSearchBarOpenState();
          }, 16);
    }

    new MutationObserver(scheduleSync).observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    [
      'algolia.instantSearch.onRender',
      'algolia.instantsearch.onRender',
      'algolia.instantSearch.afterInit',
      'algolia.instantsearch.afterInit'
    ].forEach(function (evt) {
      document.addEventListener(evt, scheduleSync);
    });
  }

  function registerKingsleyAlgoliaPlpHeadingHooks(shop) {
    if (shop.hooks._kingsleyAlgoliaPlpHeadingH2) return;
    shop.hooks._kingsleyAlgoliaPlpHeadingH2 = true;

    shop.hooks.registerHook('beforeInstantSearchNoResultTemplate', function (_defaultTemplate, html) {
      var t = shop.translations || {};
      var tryLabel = t.try || 'Try';
      var clearFiltersLabel = t.clearFilters || 'clearing the filters';
      var changeInputLabel = t.changeInput || 'changing your input';
      var noResultLabel = t.noResultFound || 'No result found';
      var orLabel = t.or || 'or';

      // Render Algolia's usual structure; sync adjusts links when filters are absent.
      return html`
        <div class="ais-hit-empty">
          <div class="ais-hit-empty--title">${noResultLabel}</div>
          <div class="ais-hit-empty--clears">
            ${tryLabel}${' '}
            <a class="ais-hit-empty--clear-filters ais-link">${clearFiltersLabel}</a>
            ${' '}${orLabel}${' '}
            <a class="ais-hit-empty--clear-input ais-link">${changeInputLabel}</a>
          </div>
        </div>
      `;
    });

    shop.hooks.registerHook('beforeInstantSearchMainTemplate', function (_defaultTemplate, data, html) {
      var plpTitleHeading = _shouldDemoteAlgoliaPlpTitleToH2()
        ? html`<h2 class="ais-h2">${shop.translations.searchTitle}</h2>`
        : html`<h1 class="ais-h2">${shop.translations.searchTitle}</h1>`;

      return html`
        <div class="ais-page">
          ${plpTitleHeading}
          <div class="ais-facets-button">
            ${shop.translations.showFilters}
          </div>
          <div class="ais-facets">
            <div class="ais-clear-refinements-container"></div>
            <div class="ais-current-refined-values-container"></div>
            ${
              shop.config.app_blocks_dynamic_widgets_beta_enabled
                ? html`<div class="ais-dynamic-widgets-container"></div>`
                : data.facets.map(function (facet) {
                    return html`
                      <div
                        class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}"
                      >
                        <label
                          for="${facet.escapedName}"
                          class="ais-range-slider--header ais-facet--header ais-header"
                          >${facet.title}</label
                        >
                        <input
                          class="ais-dropdown-checkbox"
                          type="checkbox"
                          id="${facet.escapedName}"
                          name="dropdown"
                        />
                        <div
                          class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"
                        ></div>
                      </div>
                    `;
                  })
            }
          </div>
          <div class="ais-block">
            <div class="plp-search-bar">
              <h4
                class="plp-search-label"
                role="button"
                tabindex="0"
                aria-expanded="false"
                aria-controls="ais-plp-search-input"
              >
                Search within
              </h4>
              <div class="ais-input" id="ais-plp-search-input">
                <div class="ais-search-box-container"></div>
                <div class="ais-input-button">
                  <div class="ais-clear-input-icon"></div>
                </div>
              </div>
            </div>
            <div class="ais-search-header">
              <div class="ais-stats-container"></div>
              <div class="ais-change-display">
                <span class="ais-change-display-block ais-change-display-selected"
                  ><i class="fa fa-th-large"></i
                ></span>
                <span class="ais-change-display-list"
                  ><i class="fa fa-th-list"></i
                ></span>
              </div>
              <div class="ais-sort">
                ${
                  data.multipleSortOrders
                    ? html`
                        ${shop.translations.sortBy}
                        <span class="ais-sort-orders-container"></span>
                      `
                    : html`
                        ${shop.translations.sortBy}
                        ${shop.translations.relevance}
                      `
                }
              </div>
            </div>
            <div class="ais-hits-container ais-results-as-block"></div>
          </div>
          <div class="ais-pagination-container"></div>
        </div>
      `;
    });

    _scheduleAfterRenderSyncs();
  }

  function _scheduleAfterRenderSyncs() {
    var raf = window.requestAnimationFrame
      ? window.requestAnimationFrame.bind(window)
      : function (cb) { return setTimeout(cb, 16); };
    raf(function () {
      _demoteAlgoliaPlpTitleHeading();
      _syncPlpSearchBarOpenState();
      _syncAlgoliaNoResultClearsMessage();
      _scheduleInjectors();
    });
  }

  function _setPlpSearchBarOpen(open, focusInput) {
    var label = document.querySelector('.ais-page .plp-search-label');
    var inputWrap = document.querySelector('.ais-page .plp-search-bar .ais-input');
    if (!label || !inputWrap) return;

    label.classList.toggle('active', open);
    inputWrap.classList.toggle('active', open);
    label.setAttribute('aria-expanded', open ? 'true' : 'false');

    if (open && focusInput) {
      var field = inputWrap.querySelector('.ais-SearchBox-input');
      if (field) {
        try { field.focus(); } catch (e) {}
      }
    }
  }

  function _togglePlpSearchBar(focusInput) {
    var label = document.querySelector('.ais-page .plp-search-label');
    if (!label) return;
    _setPlpSearchBarOpen(!label.classList.contains('active'), focusInput);
  }

  /** Keep "Search within" open when a query is active so users can see/clear it. */
  function _syncPlpSearchBarOpenState() {
    var inputWrap = document.querySelector('.ais-page .plp-search-bar .ais-input');
    if (!inputWrap) return;
    var field = inputWrap.querySelector('.ais-SearchBox-input');
    var hasQuery = !!(field && String(field.value || '').trim());
    if (hasQuery) {
      _setPlpSearchBarOpen(true, false);
    }
  }

  function _bindPlpSearchBarToggle() {
    if (document.documentElement._kingsleyPlpSearchBarBound) return;
    document.documentElement._kingsleyPlpSearchBarBound = true;

    document.addEventListener('click', function (e) {
      var label = e.target && e.target.closest
        ? e.target.closest('.ais-page .plp-search-label')
        : null;
      if (!label) return;
      e.preventDefault();
      _togglePlpSearchBar(true);
    });

    document.addEventListener('keydown', function (e) {
      var label = e.target && e.target.closest
        ? e.target.closest('.ais-page .plp-search-label')
        : null;
      if (!label) return;
      if (e.key !== 'Enter' && e.key !== ' ') return;
      e.preventDefault();
      _togglePlpSearchBar(true);
    });
  }

  _bindPlpSearchBarToggle();

  _whenAlgoliaShopifyHooksReady(registerKingsleyAlgoliaPlpHeadingHooks);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      _startAlgoliaPlpHeadingWatcher();
      _startAlgoliaNoResultClearsWatcher();
    });
  } else {
    _startAlgoliaPlpHeadingWatcher();
    _startAlgoliaNoResultClearsWatcher();
  }
  window.addEventListener('load', function () {
    _startAlgoliaPlpHeadingWatcher();
    _startAlgoliaNoResultClearsWatcher();
  });
})();

(function () {
  var HEADER_SEARCH_PLACEHOLDER = 'Search:';

  function isKingsleyHeaderAutocompleteContainer(cont) {
    if (!cont) return false;
    var root = document.getElementById('kingsley-header-search-root');
    if (
      cont.closest &&
      (cont.closest('#kingsley-header-search-root') || cont.closest('details-modal.header__search'))
    ) {
      return true;
    }
    return !!(root && typeof root.contains === 'function' && root.contains(cont));
  }

  function registerKingsleyHeaderAutocompleteOptions(shop) {
    if (shop.hooks._kingsleyHeaderBeforeAutocompleteOptions) return;
    shop.hooks._kingsleyHeaderBeforeAutocompleteOptions = true;

    shop.hooks.registerHook('beforeAutocompleteOptions', function (options) {
      if (!options || typeof options !== 'object') return options;

      var cont = options.container;
      if (typeof cont === 'string') {
        try {
          cont = document.querySelector(cont);
        } catch (e) {
          cont = null;
        }
      }

      if (!isKingsleyHeaderAutocompleteContainer(cont)) return options;

      options.detachedMediaQuery = 'none';
      options.placeholder = HEADER_SEARCH_PLACEHOLDER;
      return options;
    });
  }

  _whenAlgoliaShopifyHooksReady(registerKingsleyHeaderAutocompleteOptions);
})();
